import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadFile } from "../../lib/api";
import CvPaper from "../studio/CvPaper";
import { DesignPicker } from "../studio/StepDownload";
import { useCvPhoto, PhotoToggle } from "./CvPhoto";

const DESIGN_KEY = "gi_cv_design";
const fileBase = (name) => `${(name || "My").replace(/[^A-Za-z0-9]+/g, "_").replace(/^_|_$/g, "") || "My"}_CV`;

export default function CvDownloadPanel({ cv, pathFor, testid = "cv-download", allowPhoto = true }) {
  const [design, setDesign] = useState(() => localStorage.getItem(DESIGN_KEY) || "classic");
  const [busy, setBusy] = useState(null);
  const cvPhoto = useCvPhoto();
  const photo = allowPhoto ? cvPhoto : { ...cvPhoto, available: false, include: false, picture: null, query: "" };
  const pick = (d) => { setDesign(d); localStorage.setItem(DESIGN_KEY, d); };
  const get = async (fmt) => {
    setBusy(fmt);
    try {
      await downloadFile(pathFor(fmt, design) + photo.query, `${fileBase(cv?.name)}.${fmt}`);
      toast.success("Downloaded. Check your downloads folder.");
    } catch {
      toast.error("The download didn't work. Please try again.");
    } finally {
      setBusy(null);
    }
  };
  const Btn = ({ fmt, primary, children }) => (
    <button data-testid={`${testid}-${fmt}`} onClick={() => get(fmt)} disabled={busy === fmt} className={`gi-btn ${primary ? "gi-btn-primary" : "gi-btn-secondary"}`}>
      {busy === fmt ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />} {children}
    </button>
  );
  return (
    <div className="space-y-4" data-testid={testid}>
      <DesignPicker value={design} onChange={pick} />
      <div className="grid lg:grid-cols-[1fr_240px] gap-4 items-start">
        <div className="min-w-0"><CvPaper cv={cv || {}} design={design} photo={photo.picture} /></div>
        <div className="gi-card p-4 flex flex-col gap-2 lg:sticky lg:top-24">
          <div className="font-semibold text-ink mb-1">Download your CV</div>
          <PhotoToggle photo={photo} testid={`${testid}-photo`} />
          <Btn fmt="pdf" primary>Download PDF</Btn>
          <Btn fmt="docx">Download Word</Btn>
        </div>
      </div>
    </div>
  );
}
